import { Injectable } from '@angular/core';
import { RequestService } from './request.service';
import { CommonActiveService } from './common-active.service';
import { Observable } from 'rxjs';

const root_path = '/user-register';

@Injectable({
  providedIn: 'root',
})
export class UserRegisterService {
  constructor(protected requestService: RequestService) {}

  public save(
    payload: any,
    is_loading: boolean = true,
    is_snack_bar: boolean = false
  ): Observable<any> {
    return this.requestService.postJSON(`${root_path}`, {
      data: payload,
      option: {
        is_loading: is_loading,
        is_snack_bar: is_snack_bar,
      },
    });
  }
}
